import gql from "graphql-tag";
const GET_PROFILE = gql`
  query {
    returnUserProfile{
    id,
    email,
    username,
    firstname,
    surname,
    confirmed,
    isTwoFaEnabled,
    isLearnpadEnabled,
    total_gains_balance,
    learnpad_tier,
    kycStatus,
    total_staked_across_platforms,
  }
  }
`;

export default GET_PROFILE;